import type {
  GetEventRulesQuery,
  GetEventRulesQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_EVENT_RULES: TypedDocumentNode<
  GetEventRulesQuery,
  GetEventRulesQueryVariables
> = gql`
  query GetEventRules {
    eventRules {
      items {
        id
        userId
        name
        enabled
        context
        condition
        preparation
        application
        createdAt
        updatedAt
      }
      pagination {
        hasMore
        nextCursor
        totalCount
      }
    }
  }
`;
